import { Component, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { Subject } from 'rxjs';
import { QQQuestionnaireViewModel } from 'src/app/models/qq-questionnaire.view-model';
import { QuestionnaireService } from 'src/app/services/questionnaire.service';
import { Dictionary } from 'src/app/util/to-dictionary';

@Component({
  selector: 'app-bank-details-question-page',
  templateUrl: './bank-details-question-page.component.html',
  styleUrls: ['./bank-details-question-page.component.scss'],
})
export class BankDetailsQuestionPageComponent implements OnInit, OnDestroy {

  @Input() key: string;
  @Input() name: string;
  @Input() answers: Dictionary<string>;
  @Input() error: string;

  @ViewChild(NgForm) form: NgForm;

  @Output() back = new EventEmitter();
  @Output() continue = new EventEmitter<QQQuestionnaireViewModel>();

  questionnaire: QQQuestionnaireViewModel;
  dispose$ = new Subject();
  validationRetryCount: number = 0;
  loading = false;

  get page() {
    return this.questionnaire?.currentPage;
  }

  constructor(
    private questionnaireService: QuestionnaireService
  ) {
  }

  async ngOnInit() {
    this.error = null;
    this.validationRetryCount = 0;

    const answers = this.prepopulateAnswers();
    this.questionnaire = await this.questionnaireService.getQuestionnaireViewModel(this.name, true, answers);

    console.log('prepopulated answers %o', this.questionnaire.answersObject);

    this.questionnaire.pages.forEach(p => p.onQuestionAnswered.subscribe(x => this.error = null));
  }

  ngOnDestroy(): void {
    this.dispose$.next(null);
  }

  async next() {
    if (!this.questionnaire.next(this.questionnaire.currentPage)) {
      this.questionnaire.answers.forEach((value, key) => this.answers[key] = value);
      this.continue.emit(this.questionnaire);
    }
  }

  previous() {
    if (!this.questionnaire.back())
      this.back.emit();
  }

  private prepopulateAnswers() {
    const ret: any = {};
    for (const key in this.answers) {
      if (key.startsWith('DirectDebit') || key.startsWith('BankVerification') || key === 'MagnumPremium')
        ret[key] = this.answers[key];
    }

    return ret;
  }
}

